import initialState from "./initialState";

export const types = {
  SET_LAYERS: "SET_LAYERS",
  SET_ACTIVE_LAYERS: "SET_ACTIVE_LAYERS",
  reset: "reset",
};

export default {
  /**
   * Sets the layers list
   */
  [types.SET_LAYERS]: (state, layers) => {
    state.layers = layers;
    state.layersById = Object.keys(layers);
  },
  [types.SET_ACTIVE_LAYERS]: (state, layers) => {
    state.activeLayers = layers;
  },
  [types.reset]: state => {
    const newState = initialState();
    Object.keys(initialState).forEach(key => {
      state[key] = newState[key];
    });
  },
};
